import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import Back from '../common/Back';
import format from '../../helpers/format';

import style from './EndorsementDetailsPage.module.css';

const EndorsementDetailsPage = React.memo(({ match }) => {
  const [clientInformation, setClientInformation] = useState({
    Name: '',
    ClientId: '',
  });

  const [endorsement, setEndorsement] = useState({
    RequestType: '',
    RequestData: [],
    EffDate: '',
  });
  const { clientId, endorsementId } = match.params;

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      setEndorsement(data);
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}hub/clients/${clientId}/requests/endorsements/${endorsementId}`,
      )
      .then(handleSuccess);

    const handleClientInformationSuccess = ({ data }) => {
      setClientInformation(data);
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/information`,
      )
      .then(handleClientInformationSuccess);
  }, [clientId, endorsementId]);

  return (
    <div className={style.main}>
      <Back
        path={`/clients/${match.params.clientId}`}
        text={clientInformation.Name}
        clientId={clientInformation.ClientId}
      />
      <div className={style.header}>
        <h1>Endorsement Request Detail</h1>
      </div>
      <div className={style.endorsementDetails}>
        <Link to={`/clients/${clientId}/endrosements`}>
          Endorsement Requests
        </Link>
        <div className={style.details}>
          <div className={style.detailsHeader}>{endorsement.RequestType}</div>
          <div className={style.detailsContent}>
            <div>
              <span className={style.label}>
                Effective Date for this Request:
              </span>
              <span className={style.value}>
                {format.formatDate(endorsement.EffDate)}
              </span>
            </div>
            {endorsement.RequestData.map((item, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={idx}>
                <span className={style.label}>{item.Key}:</span>
                <span className={style.value}>{item.Value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

EndorsementDetailsPage.propTypes = {};

export default EndorsementDetailsPage;
